// Base URL pointing to the C# Backend (NUSConstruction API)
// Default C# local runner is hosted on port 5000 (replaces previous Node.js backend on port 5001)
const APV_API_BASE_URL = (process.env.REACT_APP_APV_API_URL || 'http://localhost:5000/api').replace(/\/+$/, '');
const ENDPOINT = `${APV_API_BASE_URL}/contracts`;

// GET all APV contracts
export async function getContracts(projectId) {
  const url = projectId ? `${ENDPOINT}?projectId=${encodeURIComponent(projectId)}` : ENDPOINT;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch contracts: ${response.status} ${response.statusText}`);
  }
  const result = await response.json();
  return result?.data || [];
}

// GET APV contract by ID
export async function getContractById(id) {
  const response = await fetch(`${ENDPOINT}/${encodeURIComponent(id)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch contract ${id}: ${response.status} ${response.statusText}`);
  }
  const result = await response.json();
  return result?.data;
}

// POST create APV contract
export async function createContract(contractData) {
  const response = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(contractData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    const error = new Error(errorData?.message || `Failed to create contract: ${response.status}`);
    error.response = { status: response.status, data: errorData };
    throw error;
  }
  const result = await response.json();
  return result?.data;
}

// PUT update APV contract
export async function updateContract(id, contractData) {
  const response = await fetch(`${ENDPOINT}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(contractData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    const error = new Error(errorData?.message || `Failed to update contract: ${response.status}`);
    error.response = { status: response.status, data: errorData };
    throw error;
  }
  const result = await response.json();
  return result?.data;
}

// DELETE APV contract
export async function deleteContract(id) {
  const response = await fetch(`${ENDPOINT}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    const error = new Error(errorData?.message || `Failed to delete contract: ${response.status}`);
    error.response = { status: response.status, data: errorData };
    throw error;
  }
  const result = await response.json();
  return result?.data;
}
